import { render, staticRenderFns } from "./TerminQrCode.vue?vue&type=template&id=7a06717c"
import script from "./TerminQrCode.vue?vue&type=script&lang=ts"
export * from "./TerminQrCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports